import axios from 'axios';

const getVideoInfo = async (videoId, state) => {
  try {
    const response = await axios.get(`/api/${state.toUpperCase()}/video/get-video/${videoId}`);
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getVideoDetails = async (videoId, state) => {
  const response = await axios.get(
    `/api/${state.toUpperCase()}/video/details/${videoId}`
  );
  return response.data;
};

const assignWitnessLobbyist = async (witnessId, lobbyistId, state) => {
  const response = await axios.post(
    `/api/${state.toUpperCase()}/video/witnesses/${witnessId}/assign-lobbyist`,
    { lobbyistId }
  );
  return response.data;
};

const searchLobbyists = async (q, state) => {
  const response = await axios.get(
    `/api/${state.toUpperCase()}/video/lobbyists/search`,
    { params: { q } }
  );
  return response.data;
};

const videoService = {
  getVideoInfo,
  getVideoDetails,
  assignWitnessLobbyist,
  searchLobbyists,
};

export default videoService;
